// @name Image
// @desc to show the Image on the screen.
// @params props- passed src,width,height.
// @author Sahithi
function Image(props) {
    return (
      <img src={props.src} alt="" style={{ width: props.logowidth, height: props.logoheight, alignItems: 'center' }} {...props} />
    )
  }
  
  export default Image;